import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container} from "react-bootstrap";
import {Header} from "./components/Header";
import {Main} from "./components/Main";
import {useState} from "react";

function App() {
    const [opacity, setOpacity] = useState(0.9);

    return (
        <Container className="app-container d-flex flex-column align-items-center px-0" fluid>
            <Header opacity={opacity}/>
            <Main setOpacity={setOpacity}/>
        </Container>
    );
}

export default App;
